export default __webpack_public_path__ + "static/media/Brett_Stein.13519a7d.png";